export enum AppManagerActionTypes {
  APP_FETCH_ALL_LOCATIONS_SUCCESS = "APP_FETCH_ALL_LOCATIONS_SUCCESS",
  APP_FETCH_RESTAURANT_GROUPS_SAGA = "APP_FETCH_RESTAURANT_GROUPS_SAGA",
  APP_FETCH_RESTAURANT_GROUPS_SUCCESS = "APP_FETCH_RESTAURANT_GROUPS_SUCCESS",
  APP_SET_CURR_LOCATION = "APP_SET_CURR_LOCATION",
  APP_SET_CURRENT_RESTAURANT_GROUP_ID = "APP_SET_CURRENT_RESTAURANT_GROUP_ID",
  SET_FULL_REFRESH_LOADER = "SET_FULL_REFRESH_LOADER",
  SET_CURRENT_LANGUAGE = "SET_CURRENT_LANGUAGE"
}